declare global {
  interface Window {
    Intercom: any;
  }
}

export const setIntercomAlignment = (alignment: 'left' | 'right') => {
  if (typeof window.Intercom === 'function') {
    window.Intercom('update', {alignment});
  }
};
